import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { EnterpriseCoordinatorSharedAddressUpsearchModel } from '@trialcard/apigateway.models';
import { Action, Mutation } from 'vuex-module-decorators';

@InjectModule({ stateFactory: true }, module)
export default class PharmacyInfomationModule extends InjectVuexModule {
    defaultPharmacyInformationData = {
        pharmacyName: '' as string,
        contactName: '' as string,
        addresses: [] as EnterpriseCoordinatorSharedAddressUpsearchModel[],
        quantity: '' as string,
    };

    pharmacyInformationData = { ...this.defaultPharmacyInformationData };

    @Mutation
    public async updatePatientInformation(newPharmacyInformationData: typeof PharmacyInfomationModule.prototype.pharmacyInformationData) {
        this.pharmacyInformationData = { ...this.pharmacyInformationData, ...newPharmacyInformationData };
    }

    @Action
    clearPharmacyInformationStore() {
        this.updatePatientInformation(this.defaultPharmacyInformationData);
    }
}
